import React, { useRef } from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

// Components
import { Button } from '../../../components/UI/Buttons'
import Input from '../../UI/TextInput'

//Styles
import { Container, InputContainer, Row, TextError } from './styled'
import { useTranslation } from 'react-i18next'

const ForgotSchema = Yup.object().shape({
  email: Yup.string().email('Formato de correo invalido').required('El correo electrónico es requerido'),
})

interface IProps {
  onSubmit: (values: any) => void
}

// MAIN
/**
 * @description Componente formulario de login
 */
const ForgotForm = (props: IProps) => {
  const { t } = useTranslation()
  const { onSubmit } = props

  const initialValues = useRef({
    email: '',
  })

  const handleSubmit = (values: any): void => {
    onSubmit(values)
  }

  return (
    <Container>
      <Formik h validationSchema={ForgotSchema} onSubmit={handleSubmit} initialValues={initialValues.current}>
        {({ errors, touched, values, handleChange, isValid }) => {
          return (
            <Form style={{ width: '100%' }}>
              <InputContainer>
                <Input
                  value={values.email}
                  onChange={handleChange('email')}
                  type="text"
                  name="email"
                  label={t('global.common.forgotPassword.inputs.email')}
                  className="input"
                  style={{ width: '100%' }}
                />
                {errors.email && touched.email ? <TextError>{errors.email}</TextError> : null}
              </InputContainer>
              <Row>
                <Button fullWidth disabled={!isValid || !values.email} size="lg" type="submit">
                  {t('global.common.forgotPassword.buttons.send')}
                </Button>
              </Row>
            </Form>
          )
        }}
      </Formik>
    </Container>
  )
}

export default ForgotForm
